const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11.656 25.84C11.88 25.616 12.16 25.504 12.496 25.504C12.832 25.504 13.112 25.616 13.336 25.84C13.56 26.08 13.672 26.36 13.672 26.68C13.672 27.16 13.48 27.496 13.096 27.688C13.08 27.704 13.04 27.72 12.976 27.736C12.912 27.768 12.848 27.792 12.784 27.808L12.712 27.856C12.712 27.872 12.752 27.92 12.832 28C12.928 28.08 13.008 28.136 13.072 28.168C13.328 28.36 13.64 28.456 14.008 28.456C14.312 28.456 14.568 28.384 14.776 28.24C15.16 28.016 15.448 27.6 15.64 26.992C15.912 26.224 16.168 24.184 16.408 20.872C16.632 17.832 16.872 15.272 17.128 13.192C17.544 9.944 17.784 8.152 17.848 7.816C18.248 5.512 19.024 3.984 20.176 3.232C20.576 2.976 21.016 2.8 21.496 2.704C21.528 2.704 21.6 2.704 21.712 2.704C21.84 2.688 21.944 2.68 22.024 2.68C22.776 2.728 23.4 2.992 23.896 3.472C24.392 3.952 24.64 4.568 24.64 5.32C24.64 5.672 24.528 5.96 24.304 6.184C24.08 6.408 23.8 6.52 23.464 6.52C23.128 6.52 22.848 6.408 22.624 6.184C22.4 5.944 22.288 5.664 22.288 5.344C22.288 4.864 22.48 4.528 22.864 4.336C22.88 4.32 22.92 4.304 22.984 4.288C23.048 4.256 23.104 4.224 23.152 4.192L23.248 4.168C23.248 4.088 23.128 3.984 22.888 3.856C22.616 3.664 22.304 3.568 21.952 3.568C21.248 3.568 20.736 3.984 20.416 4.816C20.224 5.28 20.072 5.92 19.96 6.736C19.864 7.536 19.736 9.008 19.576 11.152C19.352 14.16 19.112 16.712 18.856 18.808C18.536 21.56 18.296 23.352 18.136 24.184C17.672 26.744 16.76 28.36 15.4 29.032C14.984 29.24 14.536 29.344 14.056 29.344C12.904 29.344 12.088 28.848 11.608 27.856C11.416 27.52 11.32 27.136 11.32 26.704C11.32 26.352 11.432 26.064 11.656 25.84Z",
  fill: "#1E3F6B"
});

const SvgEquationIntegrals5 = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEquationIntegrals5, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/equation-integrals-5.58a2bad8.svg";
export { ForwardRef as ReactComponent };